<script>
    export let submenu = false;
    let rotate;
    import { fade } from 'svelte/transition';

    // $: toggle_nav = () => submenu === false ? submenu = true : submenu = false;

    function toggle_nav() {
        if (!submenu) {
            submenu = true
            rotate = "transform: rotate(-90deg)"
        }
        else {
            submenu = false
            rotate = ""
        }
    }

</script>


<nav>

    <div class="nav_container">

        <div class="nav_wrapper">

            <div class="nav_inner">

                <a href="/"><img src="assets/svgs/logo.svg" alt=""></a>

                <img on:click={toggle_nav} src="assets/svgs/menu.svg" alt="" style="{rotate}">

            </div>



            {#if submenu}

                <div class="nav_collapsed" transition:fade="{{duration: 300}}">

                    <div class="collapsed_wrapper">

                        <a href="/auth">login</a>
                        <a href="/">Cards</a>
                        <a href="/liked">Liked</a>
                        <a href="/profile"><img src="assets/svgs/user.svg" alt=""></a>

                    </div>

                </div>

            {/if}

        </div>



    </div>

</nav>

<style>

    nav {
        width: 100%;
        z-index: 10;
        position: relative;
        height: 7vh;
    }
    .nav_container {
        background-color: #F9F9F9;
        z-index: 10;
        height: 100%;

    }
    .nav_wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
        position: relative;
        z-index: 10;
        height: 100%;

    }
    .nav_wrapper .nav_inner {
        display: flex;
        justify-content: space-between;
        width: 96%;
        /*padding: 2vw 0;*/
        z-index: 10;
        align-items: center;
    }
    .nav_wrapper .nav_inner a {

    }
    .nav_wrapper .nav_inner a img {
        height: 5vh;
        width: 13vh;
        z-index: 10;
    }
    .nav_wrapper .nav_inner img {
        width: 5vh;
        transition: transform ease 0.3s;
    }
    .nav_collapsed {
        position: absolute;
        width: 100%;
        top: 100%;
        background-color: #F9F9F9;
        display: flex;
        justify-content: center;

    }
    .nav_collapsed .collapsed_wrapper {
        display: flex;
        width: 96%;
        flex-direction: column;
        align-items: center;
    }
    .nav_collapsed .collapsed_wrapper a {
        margin: 2vw 0;

    }
    .nav_collapsed .collapsed_wrapper img {
        margin: 2vw 0;
        height: 5vw;
    }

</style>